<script>
import axios from "axios";
import { Translator } from 'vue-google-translate';
export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      patients:'',
      
      arrayOfCountries:[
        {
          code: 'en|en',
          title: 'English',
        },
        {

      code: 'en|fr',

      title: 'French',

      },
       
      {

      code: 'en|ar',

      title: 'Arabic',

      },

      {

      code: 'en|es',

      title: 'Spanish',

      },

      {

      code: 'en|de',

      title: 'German',

      },

      {

      code: 'en|sw',

      flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ke.svg',

      title: 'Kiswahili',

      },

      {

      code: 'en|lg',

      flagIconUrl: 'https://flagicons.lipis.dev/flags/4x3/ug.svg',

      title: 'Luganda',

      },
      ]
    };
  },
  computed: {
    appNotifications() {
      return this.$store.state.notificationCenter?.items || [];
    },
    unreadNotificationCount() {
      return this.appNotifications.filter((item) => !item.read).length;
    },
  },
  components:{
    Translator
  },
  methods: {
    
    // customEvent() {

    // this.$router.push(this.$route.query.redirectFrom || {name: "default",})

    // },
    customEvent() {
  const redirectTo = this.$route.query.redirectFrom || { name: "default" };
  if (this.$route.name !== redirectTo.name) {
    this.$router.push(redirectTo);
  }
},

    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    getNotificationVariant(type) {
      if (type === "danger") return "danger";
      if (type === "warning") return "warning";
      if (type === "info") return "info";
      return "success";
    },
    getNotificationIcon(type) {
      if (type === "danger") return "mdi mdi-alert-circle";
      if (type === "warning") return "mdi mdi-alert";
      if (type === "info") return "mdi mdi-account-plus";
      return "mdi mdi-check-circle";
    },
    formatNotificationTime(value) {
      if (!value) return "";
      const createdAt = new Date(value);
      const now = new Date();
      const diffSeconds = Math.max(0, Math.floor((now - createdAt) / 1000));

      if (diffSeconds < 60) return "Just now";
      if (diffSeconds < 3600) return `${Math.floor(diffSeconds / 60)} min ago`;
      if (diffSeconds < 86400) return `${Math.floor(diffSeconds / 3600)} hr ago`;
      return createdAt.toLocaleDateString();
    },
    formatHumanDate(value) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    formatNotificationDetail(detail) {
      if (!detail) return "";
      const expiryPrefix = "Expiry date: ";
      if (detail.startsWith(expiryPrefix)) {
        return `${expiryPrefix}${this.formatHumanDate(detail.slice(expiryPrefix.length).trim())}`;
      }
      return detail;
    },
    async copyBatchNumber(batchNumber) {
      if (!batchNumber) return;
      try {
        await navigator.clipboard.writeText(batchNumber);
        this.$toast.success("Batch number copied.", {
          recordInCenter: false,
        });
      } catch (error) {
        this.$toast.error("Failed to copy batch number.", {
          recordInCenter: false,
        });
      }
    },
    markNotificationsRead() {
      this.$store.dispatch("notificationCenter/markAllRead");
    },
    clearNotification(id) {
      this.$store.dispatch("notificationCenter/clearNotification", id);
    },
    clearAllNotifications() {
      this.$store.dispatch("notificationCenter/clearAllNotifications");
    },
    getFiles(name){
     let url = axios.defaults.baseURL;
     let imagelink = (url).slice(0,-3)+"logos/"+name;
     return imagelink;
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo">
            <span class="logo-sm">
              <span v-if="userData.logo!=0">
                  <img :src="getFiles(userData.logo)" height="50"/>
              </span>
              <span v-else>
                  <img src="@/assets/images/logo.png" height="50"/>
              </span>
            </span>
            <span class="logo-lg">
              <span v-if="userData.logo!=0">
                  <img :src="getFiles(userData.logo)" height="80"/>
              </span>
              <span v-else>
                  <img src="@/assets/images/logo.png" height="80"/>
              </span>
            </span>
          </router-link>
        </div>

        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item" @click="toggleMenu"><i class="fa fa-fw fa-bars"></i></button>
        <span toggle-class="header-item" class="pt-4 d-none d-lg-block">
          <span class="h4">{{ userData.business }} </span>
          <span class="h6">{{ userData.location }} </span>
        </span>
      </div>
      <div class="d-flex">
      <div >
<b-dropdown right variant="black"  toggle-class="header-item">

<template v-slot:button-content>

  <b-button variant="primary" size="sm"><i class="mdi mdi-google-translate me-1"></i> Translate </b-button>

</template>
<div class="translator-dropdown">
<Translator :countries="arrayOfCountries" @on-country-click="customEvent"/>
</div>
</b-dropdown>
      </div>
        <span v-if="userData.permissions['view_reports']==1">
          <b-dropdown variant="black" class="dropdown-mega" toggle-class="header-item" menu-class="dropdown-megamenu">
            <template v-slot:button-content><i class="fas fa-clipboard"></i> Reports<i class="mdi mdi-chevron-down"></i></template>
            <div class="row">
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Patients Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="/cashpaymentsreport">Cash Payments</router-link></li>
                    <li><router-link to="/insuranceinvoices">Insurance Invoices</router-link></li>
                    <li><router-link to="/personalpaymentsreport">Personal Account Payments</router-link></li>
                    <li><router-link to="/departmentanalysisreport">Department Analysis</router-link></li>
                    <li><router-link to="/serviceanalysisreport">Service Analysis</router-link></li>
                  </ul>
                </div>
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Pharmacy Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="/pharmacypaymentsreport">Pharmacy Payments</router-link></li>
                    <li><router-link to="/purchasebysupplierreport">Purchases Per Supplier</router-link></li>
                    <li><router-link to="/pharmacypurchasereport">Pharmacy Purchases</router-link></li>
                    <li><router-link to="/productsdemand">Products Demand</router-link></li>
                    <li><router-link to="/pharmacybymonthreport">Monthly Analysis</router-link></li>
                  </ul>
                </div>
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Performance Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="/paymentsbyuserreport">Payments Per User</router-link></li>
                    <li><router-link to="/workloadbyuserreport">Workload Per User</router-link></li>
                    <li><router-link to="/labreport">Lab Performance</router-link></li>
                    <li><router-link to="/appointmentsreport">Appointments</router-link></li>
                    <li><router-link to="/expensesreport">Expenses Report</router-link></li>

                  </ul>
                </div>
                <div class="col-md-3">
                  <h5 class="font-size-14 mt-0">Other Reports</h5>
                  <ul class="list-unstyled megamenu-list">
                    <li><router-link to="/diagnosisanalysisreport">Diagnosis Analysis</router-link></li>
                    <li><router-link to="/paymentsbyoptionreport">Payments Per Payment Method</router-link></li>
                    <li><router-link to="/paymentsbymonthreport">Payments Per Month</router-link></li>
                    <li><router-link to="/cashflowreport">Income & Expenditure </router-link></li>
                    <li><router-link to="/expensesreportcategory">Expenses Report By Category</router-link></li>

                  </ul>
                </div>
            </div> 
          </b-dropdown>
        </span>

        <span v-if="userData.permissions['view_settings']==1">
        <b-dropdown
          variant="black"
          class="dropdown-mega"
          toggle-class="header-item"
          menu-class="dropdown-megamenu"
        >
          <template v-slot:button-content><i class="fas fa-cog"></i> Settings <i class="mdi mdi-chevron-down"></i>
          </template>
          <div class="row">
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">System Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="/facilityprofile">Facility Profile</router-link></li>
                  <li><router-link to="/services">Facility Services</router-link></li>
                  <li><router-link to="/paymentoptions">Payment Options</router-link></li>
                  <!-- <li><a href="javascript:void(0);">Family Accounts</a></li> -->
                  <li><router-link to="/groupaccounts">Family Accounts</router-link></li>
                  <li><router-link to="/diagnosis">Facility Diagnosis</router-link></li>
                  <li><router-link to="/facilitysettings">Facility Settings</router-link></li>

                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Pharmacy Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="/productcategories">Product Categories</router-link></li>
                  <li><router-link to="/productunits">Product Units</router-link></li>
                  <li><router-link to="/productitems">Product Items</router-link></li>
                  <li><router-link to="/productitemunits">Product Items Units</router-link></li>
                  <li><router-link to="/suppliers">Product Suppliers</router-link></li>
                  <li><router-link to="/reconcilestock">Reconcile Stock</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">Labratory Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="/labsamples">Lab Samples</router-link></li>
                  <li><router-link to="/testresults">Test Results</router-link></li>
                  <li><router-link to="/labsamples">Lab Stock</router-link></li>
                  <li><router-link to="/labsamples">Lab Stock Usage</router-link></li>
                </ul>
              </div>
              <div class="col-md-3">
                <h5 class="font-size-14 mt-0">User Management</h5>
                <ul class="list-unstyled megamenu-list">
                  <li><router-link to="/users">System Users</router-link></li>
                  <li><router-link to="/roles">System Roles</router-link></li>
                  <li><router-link to="/permissions">System Permissions</router-link></li>
                  <li><router-link to="/audits">Audit Trails</router-link></li>
                  <li><router-link to="/subscription">Subscriptions</router-link></li>
                </ul>
              </div>
          </div> 
        </b-dropdown>
        </span>   

        <b-dropdown
          right
          variant="black"
          toggle-class="header-item position-relative"
          menu-class="dropdown-menu-end notification-center-menu p-0"
          @show="markNotificationsRead"
        >
          <template v-slot:button-content>
            <div class="notification-center-trigger">
              <i class="mdi mdi-bell-outline mdi-24px"></i>
              <span v-if="unreadNotificationCount" class="badge rounded-pill bg-danger notification-center-badge">
                {{ unreadNotificationCount }}
              </span>
            </div>
          </template>

          <div class="notification-center-panel">
            <div class="notification-center-header">
              <div>
                <div class="notification-center-title">Notification Center</div>
                <div class="notification-center-subtitle">
                  {{ unreadNotificationCount ? `${unreadNotificationCount} unread` : "All caught up" }}
                </div>
              </div>
              <button
                type="button"
                class="btn btn-link btn-sm notification-center-clear"
                @click.stop="clearAllNotifications"
                :disabled="!appNotifications.length"
              >
                Clear all
              </button>
            </div>

            <div v-if="appNotifications.length" class="notification-center-list">
              <div
                v-for="item in appNotifications"
                :key="item.id"
                class="notification-center-item"
                :class="[`notification-center-item--${getNotificationVariant(item.type)}`, { 'notification-center-item--read': item.read }]"
              >
                <div class="notification-center-item-icon">
                  <i :class="getNotificationIcon(item.type)"></i>
                </div>
                <div class="notification-center-item-body">
                  <div class="notification-center-item-top">
                    <div class="notification-center-item-title">
                      {{ item.title || item.message }}
                    </div>
                    <button
                      type="button"
                      class="notification-center-item-close"
                      @click.stop="clearNotification(item.id)"
                      aria-label="Clear notification"
                    >
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                  <div v-if="item.title" class="notification-center-item-message">
                    {{ item.message }}
                  </div>
                  <div v-if="item.productName || item.batchNumber" class="notification-center-item-meta">
                    <span v-if="item.productName">Product: {{ item.productName }}</span>
                    <span v-if="item.batchNumber" class="notification-center-batch-meta">
                      Batch: {{ item.batchNumber }}
                      <button
                        type="button"
                        class="notification-center-copy"
                        @click.stop="copyBatchNumber(item.batchNumber)"
                        aria-label="Copy batch number"
                        title="Copy batch number"
                      >
                        <i class="mdi mdi-content-copy"></i>
                      </button>
                    </span>
                  </div>
                  <ul v-if="item.details && item.details.length" class="notification-center-item-details">
                    <li v-for="(detail, index) in item.details" :key="`${item.id}-${index}`">{{ formatNotificationDetail(detail) }}</li>
                  </ul>
                  <div class="notification-center-item-time">
                    {{ formatNotificationTime(item.createdAt) }}
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="notification-center-empty">
              <i class="mdi mdi-bell-check-outline"></i>
              <div>No important notifications yet.</div>
            </div>
          </div>
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item" menu-class="dropdown-menu-end">
          <template v-slot:button-content>
            <i class="mdi mdi-account-circle mdi-24px"></i>
            <span class="d-none d-xl-inline-block mt-n2 ms-1">
              {{ userData.username }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i>
            Logout
          </a>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style scoped>
.notification-center-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
}

.notification-center-badge {
  position: absolute;
  top: -6px;
  right: -12px;
  min-width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0 0.35rem;
}

.notification-center-panel {
  width: min(420px, 92vw);
  background: #fff;
}

.notification-center-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1rem 0.85rem;
  border-bottom: 1px solid #eef1f7;
}

.notification-center-title {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1f2937;
}

.notification-center-subtitle {
  margin-top: 0.2rem;
  font-size: 0.78rem;
  color: #6b7280;
}

.notification-center-clear {
  padding: 0 !important;
  color: #0f766e !important;
  text-decoration: none !important;
}

.notification-center-list {
  max-height: 380px;
  overflow-y: auto;
}

.notification-center-item {
  display: flex;
  gap: 0.85rem;
  padding: 0.95rem 1rem;
  border-bottom: 1px solid #f3f4f6;
  background: #fff;
}

.notification-center-item--read {
  opacity: 0.78;
}

.notification-center-item-icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  font-size: 1.05rem;
}

.notification-center-item--danger .notification-center-item-icon {
  background: #fee2e2;
  color: #b91c1c;
}

.notification-center-item--warning .notification-center-item-icon {
  background: #ffedd5;
  color: #c2410c;
}

.notification-center-item--success .notification-center-item-icon {
  background: #dcfce7;
  color: #15803d;
}

.notification-center-item--info .notification-center-item-icon {
  background: #dbeafe;
  color: #1d4ed8;
}

.notification-center-item-body {
  min-width: 0;
  flex: 1;
}

.notification-center-item-top {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  justify-content: space-between;
}

.notification-center-item-title {
  font-weight: 700;
  color: #1f2937;
  line-height: 1.35;
}

.notification-center-item-close {
  border: 0;
  background: transparent;
  padding: 0;
  color: #111827;
  font-size: 1rem;
  line-height: 1;
}

.notification-center-item-message {
  margin-top: 0.3rem;
  color: #4b5563;
  line-height: 1.45;
}

.notification-center-item-meta {
  margin-top: 0.45rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem 0.9rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #0f766e;
}

.notification-center-batch-meta {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.notification-center-copy {
  border: 0;
  background: transparent;
  color: #0f766e;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.95rem;
}

.notification-center-item-details {
  margin: 0.5rem 0 0;
  padding-left: 1rem;
  color: #6b7280;
  font-size: 0.78rem;
}

.notification-center-item-details li + li {
  margin-top: 0.2rem;
}

.notification-center-item-time {
  margin-top: 0.55rem;
  font-size: 0.74rem;
  color: #9ca3af;
}

.notification-center-empty {
  padding: 1.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: #6b7280;
}

.notification-center-empty i {
  font-size: 1.2rem;
  color: #0f766e;
}

.dropdown-mega .megamenu-list a {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0.15rem 0;
  border-radius: 0.35rem;
  color: #495057;
  transition: color 0.15s ease, background-color 0.15s ease;
}

.dropdown-mega .megamenu-list a.router-link-exact-active,
.dropdown-mega .megamenu-list a.router-link-active {
  color: #0f766e;
  font-weight: 700;
}
</style>
